import style from './vacancies-section.module.scss';
import template from '@components/careers/vacancies/vacancies.module.scss';
import { ISortItem, IVacanciesItem } from '@components/careers/vacancies/vacancies.interfaces';
import { useEffect, useState } from 'react';
import SortComponent from './sort-component/sort-component';
import Link from 'next/link';
import { getVacancies } from '@services/vacancy.services';

interface IVacanciesSectionProps {
  title: string;
  vacancies: IVacanciesItem[];
  sort: ISortItem[];
  vacanciesTotal: number;
}

const filterShowNumber = 10;
const VacanciesSection = ({ title, vacancies, vacanciesTotal, sort }: IVacanciesSectionProps) => {
  const [sortedVacancies, setSortedVacancies] = useState([...vacancies]);
  const [departmentSortList, setDepartmentSortList]: any = useState(['All']);
  const [locationSortList, setLocationSortList] = useState(['All']);
  const [departmentActiveValue, setDepartmentActiveValue] = useState(departmentSortList[0]);
  const [locationActiveValue, setLocationActiveValue] = useState(locationSortList[0]);
  let vacanciesLength = vacancies.length - 1;
  const filterHidden = vacancies.length > filterShowNumber;

  useEffect(() => {
    const dataTitles: string[] = Array.from(
      new Set(
        vacancies.map((item: IVacanciesItem) => {
          return item.speciality.title;
        }),
      ),
    );
    setDepartmentSortList([...departmentSortList, ...dataTitles]);
    let locationTitlesArray: string[] = [];
    vacancies.forEach((item: IVacanciesItem) => {
      locationTitlesArray = [...locationTitlesArray, ...item.locations];
    });
    const locationTitles: string[] = Array.from(new Set([...locationSortList, ...locationTitlesArray]));
    setLocationSortList(locationTitles);
  }, []);

  useEffect(() => {
    getVacancies(0, undefined, undefined, locationActiveValue, departmentActiveValue)
      .then((data) => {
        setSortedVacancies(data.data);
      })
      .catch((e) => {});
  }, [departmentActiveValue, locationActiveValue]);

  return (
    <section id="currentJobs" className={`${template.section} ${template.section_light} ${style.section}`}>
      <div
        className={`${template.container} ${template.container_small} ${template.title} ${template.title_large} ${template.text_align_c} ${template.mb40}`}
      >
        {title}
      </div>

      <div
        className={`${template.container} ${template.container_small} ${filterHidden ? style.sort__block : style.sort__hidden}`}
      >
        {sort.map((item: ISortItem, index: number) => {
          return (
            <SortComponent
              key={index}
              title={item.title}
              list={index === 0 ? locationSortList : departmentSortList}
              activeValue={index === 0 ? locationActiveValue : departmentActiveValue}
              setActiveValue={index === 0 ? setLocationActiveValue : setDepartmentActiveValue}
            />
          );
        })}
      </div>
      {sortedVacancies.length > 0 ? (
        <>
          <div className={`${template.container} ${template.container_large} ${style.container}`}>
            <div className={`${style.table__list}`}>
              <div className={`${style.table__list__item}`}>Title</div>
              <div className={`${style.table__list__item} ${style.mobile_hide}`}>Employment</div>
              <div className={`${style.table__list__item} ${style.mobile_hide}`}>Location</div>
            </div>
            {sortedVacancies.map((item: IVacanciesItem, index: number) => {
              return (
                <div
                  key={index}
                  className={`${vacanciesLength === index ? style.item_last : null} ${index % 2 === 0 ? `${style.item} ${style.item_light}` : `${style.item} ${style.item_gray}`}`}
                >
                  <div className={`${style.item__vacancy} ${style.item__block}`}>{item.vacancyTitle}</div>
                  <div className={`${style.item__level} ${style.item__block} ${style.mobile_hide}`}>
                    {item.level.name}
                  </div>
                  <div className={`${style.item__location} ${style.item__block} ${style.mobile_hide}`}>
                    {item.locations.join(', ')}
                  </div>
                  <div className={`${style.button_apply} ${style.item__block}`}>
                    <Link href={`/careers/${item.slug}`}>
                      <a>See the offer</a>
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <div className={`${style.no_vacancies}`}>
          We currently don’t have any open positions, but we’re always eager to receive your CV!
        </div>
      )}
    </section>
  );
};

export default VacanciesSection;
